import React from 'react';
import { SvgIconComponent } from '@mui/icons-material';

interface TimeMetricCardProps {
  icon: SvgIconComponent;
  label: string;
  value: string;
  unit: string;
  colorScheme: 'amber' | 'emerald';
}

export const TimeMetricCard: React.FC<TimeMetricCardProps> = ({
  icon: Icon,
  label,
  value,
  unit,
  colorScheme,
}) => {
  const colors = {
    amber: {
      bg: 'bg-amber-50/50',
      bgHover: 'hover:bg-amber-50',
      border: 'border-amber-100/50',
      icon: 'text-amber-500',
      label: 'text-amber-700',
      value: 'text-amber-600',
    },
    emerald: {
      bg: 'bg-emerald-50/50',
      bgHover: 'hover:bg-emerald-50',
      border: 'border-emerald-100/50',
      icon: 'text-emerald-500',
      label: 'text-emerald-700',
      value: 'text-emerald-600',
    },
  };

  const scheme = colors[colorScheme];

  return (
    <div
      className={`${scheme.bg} p-5 rounded-xl border ${scheme.border} group ${scheme.bgHover} transition-colors`}
    >
      <div className='flex items-center gap-2 mb-2'>
        <Icon className={`w-5 h-5 ${scheme.icon}`} />
        <span
          className={`text-sm font-bold ${scheme.label} uppercase tracking-tight`}
        >
          {label}
        </span>
      </div>
      <p className={`text-3xl font-black ${scheme.value}`}>
        {value}
        <span className='text-lg ml-0.5'>{unit}</span>
      </p>
    </div>
  );
};
